import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/links';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = document.getElementById('first-cta');
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="2fuegyu52sy6f">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:px-6 sm:pb-5" data-id="element-34" data-mp="2ft3b8os2lgco">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl border-2 border-white/30 bg-cta px-4 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-8px_rgba(10,51,40,0.6)] hover:bg-ctaDark" data-id="element-35" data-mp="33intf5geg9kw">
            <span className="whitespace-nowrap" data-id="element-36" data-mp="2ub901euehqhb">Start my 21 days · $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-37" data-mp="2u94ocaq9fn6h" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}